var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f140c21a60115af0c83c0308838488d472fbc5cd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ding-frontend@seedbits-co"]={id:"f140c21a60115af0c83c0308838488d472fbc5cd"};
      